import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../public/Home-Page-Help.png'
import _imports_1 from '../../public/PoweredBy.png'


const _withScopeId = n => (_pushScopeId("data-v-bbaeed54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-block" }
const _hoisted_2 = { class: "icon" }
const _hoisted_3 = {
  key: 1,
  class: "acquaint-app-home-page"
}
const _hoisted_4 = {
  key: 0,
  class: "full-mode-home-page"
}
const _hoisted_5 = { class: "home-page-title-card" }
const _hoisted_6 = { class: "acquaint-home-container" }
const _hoisted_7 = { class: "title-container-text" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Welcome to Acquaint Web, our new web based Acquaint CRM.", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "We will be adding new functionality on a regular basis.", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Our ultimate aim is to provide all the features you use in Desktop Acquaint via a modern, browser-based interface.", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Learn More", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Need Help?", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "quadrent" }
const _hoisted_16 = {
  key: 0,
  class: "powered-by-container"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_18 = [
  _hoisted_17
]

import UtilitySwitchingAgentPanel from '@/components/home-page/utility-switching-agent-panel.vue';
import UtilitySwitchingCouncilPanel from '@/components/home-page/utility-switching-council-panel.vue';
import HomeIcon from '@/components/icons/home-icon.vue';
import PageHeading from '@/components/ui/labels/page-heading.vue';
import { AppMode } from '@/enums/system/AppMode';
import { useCurrentUserStore } from '@/stores/CurrentUserStore';
import { CurrentUser } from '@/types/user/CurrentUser';
import { computed, onMounted, ref } from 'vue';
import HomeCarousel from '@/components/home-page/home-carousel.vue';
import { useHomeCarouselStore } from '@/stores/HomeCarouselStore';
import InfoCard from '@/components/ui/containers/info-card.vue';
import { DxButton } from 'devextreme-vue';
import TaskCard from '@/components/home-page/task-card.vue';
import AppointmentsCard from '@/components/home-page/appointments-card.vue';
import JournalCard from '@/components/home-page/journal-card.vue';
import AnnouncementsCard from '@/components/home-page/announcements-card.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'home-page',
  setup(__props) {

const currentUserStore = useCurrentUserStore();
const currentUser = ref<CurrentUser>();
const homeCarouselStore = useHomeCarouselStore();
const displayCarousel = ref(false);

onMounted(async () => {
  currentUser.value = await currentUserStore.getCurrentUserDetails();
  displayCarousel.value = !await homeCarouselStore.checkIfCarouselHasBeenShown();
  if (displayCarousel.value) {
    homeCarouselStore.carouselHasBeenShown();
  }
});

// Title card
const title = computed(() => currentUser.value ? `Hi ${currentUser.value.name},` : 'Hi there,');

const openGettingStartedPage = () => {
  window.open('https://acquaintweb.scrollhelp.site/home/getting-started');
};

const openNewFeaturesPage = () => {
  window.open('https://acquaintweb.scrollhelp.site/home/whats-new');
};

const openHelpPage = () => {
  window.open('https://acquaintweb.scrollhelp.site/home/');
};

// Layout
const width = computed(() => { 
  if(screen.width < 768){
    return '100%';
  }
  return 'calc(50% - 0.5rem)'; 
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (currentUser.value?.appMode != _unref(AppMode).Full)
        ? (_openBlock(), _createBlock(PageHeading, {
            key: 0,
            title: "Home"
          }, {
            customIcon: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(HomeIcon)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (currentUser.value?.appMode == _unref(AppMode).Full)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _createVNode(HomeCarousel, {
              modelValue: displayCarousel.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((displayCarousel).value = $event))
            }, null, 8, ["modelValue"]),
            (!displayCarousel.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(InfoCard, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("h3", null, _toDisplayString(title.value), 1),
                            _hoisted_8,
                            _hoisted_9,
                            _hoisted_10,
                            _hoisted_11,
                            _createVNode(_unref(DxButton), {
                              text: "Getting Started",
                              onClick: openGettingStartedPage,
                              width: "130px"
                            }),
                            _createVNode(_unref(DxButton), {
                              text: "What's New",
                              onClick: openNewFeaturesPage,
                              width: "130px"
                            })
                          ]),
                          _createElementVNode("div", {
                            class: "need-help-container",
                            onClick: openHelpPage
                          }, _hoisted_14)
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(InfoCard, {
                      title: "Outstanding Tasks",
                      width: width.value
                    }, {
                      default: _withCtx(() => [
                        _createVNode(TaskCard)
                      ]),
                      _: 1
                    }, 8, ["width"]),
                    _createVNode(InfoCard, {
                      title: "Upcoming Appointments",
                      width: width.value
                    }, {
                      default: _withCtx(() => [
                        _createVNode(AppointmentsCard)
                      ]),
                      _: 1
                    }, 8, ["width"]),
                    _createVNode(InfoCard, {
                      title: "Recent Property Changes",
                      width: width.value
                    }, {
                      default: _withCtx(() => [
                        _createVNode(JournalCard)
                      ]),
                      _: 1
                    }, 8, ["width"]),
                    _createVNode(AnnouncementsCard, { width: width.value }, null, 8, ["width"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (currentUser.value?.appMode == _unref(AppMode).UtilitySwitchingAgent)
        ? (_openBlock(), _createBlock(UtilitySwitchingAgentPanel, { key: 2 }))
        : (currentUser.value?.appMode == _unref(AppMode).UtilitySwitchingCouncil)
          ? (_openBlock(), _createBlock(UtilitySwitchingCouncilPanel, { key: 3 }))
          : _createCommentVNode("", true)
    ]),
    (currentUser.value?.appMode != _unref(AppMode).Full)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_18))
      : _createCommentVNode("", true)
  ], 64))
}
}

})